/**
 * @generated SignedSource<<19639dd6d75f8e30134613451a6916d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZohoRegisterAuthInput = {
  clientMutationId?: string | null | undefined;
  code: string;
};
export type Integration_ZohoRegisterAuth_Mutation$variables = {
  input: ZohoRegisterAuthInput;
};
export type Integration_ZohoRegisterAuth_Mutation$data = {
  readonly zohoRegisterAuth: {
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type Integration_ZohoRegisterAuth_Mutation = {
  response: Integration_ZohoRegisterAuth_Mutation$data;
  variables: Integration_ZohoRegisterAuth_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ZohoRegisterAuthPayload",
    "kind": "LinkedField",
    "name": "zohoRegisterAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_ZohoRegisterAuth_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_ZohoRegisterAuth_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f487b73726403a8d6212f494ff9dd672",
    "id": null,
    "metadata": {},
    "name": "Integration_ZohoRegisterAuth_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_ZohoRegisterAuth_Mutation(\n  $input: ZohoRegisterAuthInput!\n) {\n  zohoRegisterAuth(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "521fa880abc7b79c95d55a794f95714d";

export default node;
